export default __webpack_public_path__ + "static/media/accept-invitation.49488187.svg";